export default {
  es: {
    title1: "Somos",
    title2: "la energía con personalidad propia",
    baratos: {
      title: "Baratos",
      intro: "Luz y Gas a precio de una merienda",
      text: "<p>En Iner, te lo ponemos fácil: comparamos el precio de la luz y el gas con cosas de tu día a día para que sepas exactamente lo que pagas. Así, tú mismo puedes comprobar que ofrecemos tarifas baratas y una gestión transparente.</p><p>Tu cuota fija mensual en Iner cuesta lo mismo que un helado, un par de cafés o un par de billetes de metro. ¡Ahorro sin complicaciones!</p><p>Nuestro compromiso es garantizarte siempre las mejores tarifas y las condiciones más competitivas del mercado.</p>",
    },
    cercanos: {
      title: "Cercanos",
      intro: "¡Llámanos y pregunta por tu agente de confianza!",
      text: "En Iner, nos encanta la cercanía del tú a tú. Por eso, cuando nos llames, hablarás directamente con tu agente de confianza: Pilar, Luis, Mª Carmen, o cualquiera de nuestro equipo. ¡Nada de contestadores automáticos ni máquinas haciendo nuestro trabajo! Y, sobre todo, sin llamadas de spam, estés o no con Iner. Respetamos tu tranquilidad y solo contactamos contigo si tú quieres.",
    },
    claros: {
      title: "Claros",
      intro: "Presume de entender tu factura de luz y gas",
      text: "<p>Sabemos que el sector de la electricidad y del gas está lleno de conceptos desconocidos para la gran mayoría de personas y al final no sabemos ni lo que estamos pagando.</p><p>Por eso en Iner nos dedicamos cada día a resolver tus dudas y explicarte de la manera más clara y sencilla todo lo que necesites. Nuestro objetivo es que entiendas tu factura de la luz y del gas con la misma claridad que en esta imagen ves el trozo de tarta que te va a tocar.</p>",
    },
    libres: {
      title: "Libres",
      intro: "Sin permanencia en tu contrato de luz y gas",

      text: "En Iner, tú decides cuándo contratar y cuándo cambiar, sin penalizaciones ni ataduras. Disfruta de la libertad de una comercializadora de energía flexible y sin compromisos.",
    },
    practicos: {
      title: "prácticos",
      intro: "A veces las cosas son una simple puntada",

      text: "¡Cómo en la vida misma! ¿No crees que hay veces que le damos demasiadas vueltas a cosas que en realidad son mucho más sencillas? ",
    },
    comoTu: {
      title: "Como tú",
      intro:
        "En Iner Energía, no somos solo una comercializadora de luz y gas, somos personas como tú",
      text: "<p>Gente real, con nombre, familia, amigos y ganas de hacer las cosas bien. Nos levantamos cada día para ofrecerte tarifas justas, un servicio de calidad y esa cercanía que marca la diferencia.</p><p>Hablamos claro, sin tecnicismos ni rodeos, porque queremos que sientas que estás en buenas manos. ¿Buscas el mejor precio para tu luz y gas? Lo tenemos. ¿Quieres un trato humano y soluciones a medida? Eso es lo nuestro. Y sí, después del trabajo también nos gusta tomarnos algo, como a las personas normales.</p>",
    },
    expertos: {
      title1: "Somos",
      title2: "expertos en el sector",
      superTitle: "<h2>Más de<br>10 años<br>en el sector</h2>",
      historia: {
        title: "Historia",
        text: "Iner Energía es una comercializadora de luz y gas con más de 10 años de experiencia en Castilla-La Mancha. Fundada por expertos en energías renovables, ofrecemos energía sostenible y tarifas competitivas, alejados de las prácticas negativas del sector.",
      },
      experiencia: {
        title: "Experiencia",
        text: "Hoy, varios años después, seguimos trabajando cada día para ofrecer a nuestros Iners el servicio que necesitan: luz y gas a precio de coste. Un servicio transparente, sin sorpresas, fruto del trabajo y la experiencia de nuestros profesionales.",
      },
      equipo: {
        title: "Equipo",
        text: "En Iner, como comercializadora de luz y gas, nuestro equipo trabaja unido para diseñar los mejores servicios energéticos y ofrecer a nuestros clientes un trato más cercano y personalizado que las grandes compañías eléctricas.",
      },
    },
  },
  en: {},
};



// WEBPACK FOOTER //
// ./src/translations/asi-somos.js